export default (input?: string, name = ''): string | never => {
  if (typeof input !== 'string') throw new Error(`Missing env var${name ? `: ${name}.` : '.'}`);
  return input;
};
